import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerProps,
  Flex,
  HStack,
  Input,
  Tab,
  Table,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Image,
  Button,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { calculatePrice, getThuaLienKe, savePrice } from "../apis/giadat.api";
import { thuaDatChiTiet as mockThua } from "../_mocks_";
import { useCalculatePrice, useHistory, useSelectedGeometries } from "../hook";
import {
  IChiTietDinhGia,
  IChiTietThuaDat,
  IDinhGia,
  IDisplayGeo,
  IDropdownItem,
  IThuaDatIdentity,
  IThuaDatLienKe,
} from "../_types_";
import Dropdown from "./Dropdown";
import LichSuGiaDat from "./LichSuGiaDat";
import { getToast, numberFormat } from "../utils";
import InputCustom from "./common/InputCustom";
import WaitingModal from "../containers/WaitingModal";
import { useGlobal } from "../contexts/Globals";

interface IProps extends Omit<DrawerProps, "children">, IThuaDatIdentity {
  setSelectedGeometries: (data: IDisplayGeo[]) => void;
}
export default function DinhGiaThuaLienKe({
  isOpen,
  onClose,
  maHuyen,
  maXa,
  soTo,
  soThua,
  setSelectedGeometries: parentSelectedGeometries,
}: IProps) {
  const { isHasEditRole } = useGlobal();
  const [isRecal, setIsRecal] = useState<boolean>(false);

  const [tabIndex, setTabIndex] = useState(0);
  const [isNotFound, setIsNotFound] = useState(false);
  const [thuaDatChiTiet, setThuaDatChiTiet] =
    useState<IChiTietThuaDat>(mockThua);
  const { thuaDat } = thuaDatChiTiet;
  const btnRef = React.useRef(null);
  const [mdsd, setMdsd] = React.useState<IDropdownItem[]>([]);
  const [dsDinhGia, setDsDinhGia] = useState<IDropdownItem[]>([]);
  const [dinhGia, setDinhGia] = useState<IDinhGia>();
  const [chiTiet, setChiTiet] = useState<IChiTietDinhGia[]>([]);
  const [thuaLienKes, setThuaLienKes] = useState<IThuaDatLienKe[]>([]);

  const [indexDinhGia, setIndexDinhGia] = useState<number>(-1);
  const [thuaDatIdentity, setThuaDatIdentity] = useState<IThuaDatIdentity>({
    maHuyen: maHuyen,
    maXa: maXa,
    soTo: soTo,
    soThua: soThua,
  });
  const [history, setHistory] = useHistory(thuaDatIdentity);
  const { giaDat, isLoading } = useCalculatePrice(thuaDatIdentity);
  const [geometries, setSelectedGeometries] =
    useSelectedGeometries(thuaDatIdentity);
  const [thuaLienKeSelectIndex, setThuaLienKeSelectIndex] = useState<number>(0);
  const toast = useToast();
  function geoFromDinhGia() {
    const dinhGiaSelect = thuaDatChiTiet.dinhGias[indexDinhGia];
    let geos: IDisplayGeo[] = [];
    if (dinhGiaSelect && dinhGiaSelect.geometries) {
      geos = dinhGiaSelect?.geometries?.map((q) => {
        const dgeo: IDisplayGeo = {
          color: q.color,
          geo: q.geometry,
        };
        return dgeo;
      });
    }

    //route geo
    const routeGeo = dinhGiaSelect?.routeGeometries;
    if (routeGeo && routeGeo.length > 0) {
      const dRGeo = routeGeo.map((m) => {
        const dgeo: IDisplayGeo = {
          color: "",
          geo: m,
        };
        return dgeo;
      });
      geos.push(...dRGeo);
    }
    return geos;
  }

  const initThuaLienKe = useCallback(async () => {
    if (thuaDatIdentity) {
      try {
        let data = await getThuaLienKe(
          thuaDatIdentity.maHuyen,
          thuaDatIdentity.maXa,
          thuaDatIdentity.soTo,
          thuaDatIdentity.soThua
        );
        setThuaLienKes(data);
        setThuaLienKeSelectIndex(0);
      } catch (er) {
        setThuaLienKes([]);
      }
    }
  }, [thuaDatIdentity]);

  useEffect(() => {
    initData();
  }, [thuaDatChiTiet]);

  useEffect(() => {
    initThuaLienKe();
  }, [initThuaLienKe]);

  useEffect(() => {
    if (isOpen) {
      const geos = geoFromDinhGia();
      setSelectedGeometries(geos);
    } else {
      //setSelectedGeometries([]);
    }
  }, [isOpen]);

  useEffect(() => {
    setThuaDatIdentity({
      maHuyen: maHuyen,
      maXa: maXa,
      soTo: soTo,
      soThua: soThua,
    });
    if (isOpen) {
      const geos = geoFromDinhGia();
      setSelectedGeometries(geos);
    }
  }, [maHuyen, maXa, soTo, soThua]);

  // useEffect(() => {}, [history]);

  useEffect(() => {
    if (giaDat) {
      setThuaDatChiTiet(giaDat);
      setIsNotFound(false);
    } else setIsNotFound(true);
  }, [giaDat]);

  useEffect(() => {
    try {
      if (indexDinhGia < 0) return;
      const dinhGiaSelect = thuaDatChiTiet.dinhGias[indexDinhGia];
      const thua = thuaLienKes[thuaLienKeSelectIndex];
      const geos = geoFromDinhGia();

      //.concat(thua ? [thua?.geometry] : []);
      //thua geo
      const geoThua = thua?.geometry;
      if (geoThua) {
        geos.push({ color: "", geo: geoThua });
      }
      setSelectedGeometries(geos);
      setDinhGia(dinhGiaSelect);
      setChiTiet(dinhGiaSelect.chiTiets);
    } catch (error) {}
  }, [indexDinhGia]);

  useEffect(() => {
    parentSelectedGeometries(geometries);
  }, [geometries]);

  const initData = () => {
    const mdResult = thuaDatChiTiet.thuaDat.mucDichSuDungs.map((p) => {
      const item: IDropdownItem = {
        value: p.kyHieu,
        lable: p.kyHieu,
      };
      return item;
    });
    setMdsd(mdResult);
    const rs = thuaDatChiTiet.dinhGias.map((p, index) => {
      const item: IDropdownItem = {
        lable: `${p.tenDuong} ${
          p.tenHem ?? p.chieuDaiHem ? p.chieuDaiHem : ""
        }`,
        value: index,
      };
      return item;
    });
    setDsDinhGia(rs);
    setIndexDinhGia(0);
  };

  const handleChangeValue = (
    index: number,
    val: string | number,
    type: "MDSD" | "DIEN_TICH" | "GIA"
  ) => {
    const newChiTiet = [...chiTiet];
    switch (type) {
      case "MDSD": {
        newChiTiet[index].mdsd = val.toString();
        break;
      }
      case "DIEN_TICH": {
        newChiTiet[index].dienTich = Number.parseFloat(val.toString());
        break;
      }
      case "GIA": {
        newChiTiet[index].gia = Number.parseFloat(val.toString());
        tinhGiaMoi(newChiTiet);
        break;
      }
      default:
        break;
    }
    setChiTiet(newChiTiet);
  };

  const handleChangeGiaValue = (val: number) => {
    if (!dinhGia) return;
    setDinhGia({ ...dinhGia, giaThiTruong: val });
  };

  const handleSaveClick = async () => {
    if (!dinhGia) return;
    try {
      let dinhGiaSave = null;
      if (!dinhGia.routeGeometries)
        dinhGiaSave = { ...dinhGia, routeGeometries: [] };
      else dinhGiaSave = { ...dinhGia };
      const request = { ...thuaDatIdentity, ...dinhGiaSave, chiTiets: chiTiet };
      await savePrice(maHuyen, maXa, request);
      await setHistory();
      setTabIndex(0);
    } catch (er: any) {
      console.log("handleSaveClick", er);
      toast(getToast(er.ChiTiets[0].toString(), "error", "error"));
    }
  };

  useEffect(() => {
    if (thuaLienKeSelectIndex >= 0 && thuaLienKes.length > 0) {
      setIndexDinhGia(-1);
      const thua = thuaLienKes[thuaLienKeSelectIndex];
      const geos = [{ color: "", geo: thua?.geometry }];
      setSelectedGeometries(geos);
      getDinhGia(maHuyen, maXa, soTo, soThua, thua.soTo, thua.soThua);
    }
  }, [thuaLienKeSelectIndex, thuaLienKes]);

  const getDinhGia = async (
    maHuyen: string,
    maXa: string,
    soTo: number,
    soThua: number,
    soToLk: number,
    soThuaLk: number
  ) => {
    setIsRecal(true);
    try {
      let tempdgs = await calculatePrice(
        maHuyen,
        maXa,
        soTo,
        soThua,
        soToLk,
        soThuaLk
      );
      setThuaDatChiTiet(tempdgs);
    } catch (er) {
      console.log(er);
    }
    setIsRecal(false);
  };

  const tinhGiaMoi = (chiTiet: IChiTietDinhGia[]) => {
    if (!dinhGia) return;
    let tongChiTiet = 0;
    chiTiet.forEach((p) => (tongChiTiet += p.gia));
    let tongGia = tongChiTiet * dinhGia.heSoTiepGiapDuong;
    setDinhGia({ ...dinhGia, tongGia });
  };

  const getDescription = useMemo(() => {
    if (!thuaLienKes || thuaLienKes.length < 1) return "";
    const thua = thuaLienKes[thuaLienKeSelectIndex];
    return `Định giá thửa đất không giáp đường theo thửa đất liền kề ${thua.soThua}(${thua.soTo})`;
  }, [thuaLienKes, thuaLienKeSelectIndex]);

  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>{`Định Giá Theo Thửa Liền Kề: ${thuaDat.soTo}/${thuaDat.soThua}`}</DrawerHeader>
          <DrawerBody>
            {!isNotFound && !isLoading && (
              <Flex
                w="full"
                flexDirection="column"
                mt="20px"
                border="1px solid #fff"
                padding="5px"
                borderRadius="5px"
                boxShadow="base"
              >
                <TableContainer w="full">
                  <Table size="sm">
                    <Thead>
                      <Tr>
                        <Th>Số tờ</Th>
                        <Th>Số thửa</Th>
                        <Th>MĐSD</Th>
                        <Th>Diện tích</Th>
                        <Th></Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {thuaLienKes.map((p, index) => {
                        return (
                          <Tr
                            cursor="pointer"
                            key={String(index)}
                            onClick={() => {
                              setThuaLienKeSelectIndex(index);
                            }}
                          >
                            <Td
                              bg={
                                index == thuaLienKeSelectIndex ? "#bee3f8" : ""
                              }
                            >
                              {p.soTo}
                            </Td>
                            <Td
                              bg={
                                index == thuaLienKeSelectIndex ? "#bee3f8" : ""
                              }
                            >
                              {p.soThua}
                            </Td>
                            <Td
                              bg={
                                index == thuaLienKeSelectIndex ? "#bee3f8" : ""
                              }
                            >
                              {p.mdsd}
                            </Td>
                            <Td
                              bg={
                                index == thuaLienKeSelectIndex ? "#bee3f8" : ""
                              }
                            >
                              {p.dienTich}
                            </Td>
                            <Td
                              bg={
                                index == thuaLienKeSelectIndex ? "#bee3f8" : ""
                              }
                            >
                              <HStack></HStack>
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Flex>
            )}
            {isNotFound && !isLoading && (
              <Flex
                w="90%"
                flexDirection="column"
                margin="auto"
                borderRadius="10px"
                mt="20px"
              >
                <Image src="./404.svg" />
                <Text
                  fontWeight="bold"
                  fontSize="20px"
                  margin="10px auto"
                  color="rgba(0,0,0, 0.8)"
                >
                  Thửa đất công tồn tại
                </Text>
              </Flex>
            )}
            <Tabs
              hidden={isNotFound}
              isFitted
              variant="soft-rounded"
              index={tabIndex}
              onChange={(index) => {
                setTabIndex(index);
              }}
            >
              <TabList mb="1em">
                {history && history.dinhGias?.length != 0 && (
                  <Tab key={history.dinhGias[0]?.tongGia}>Lịch sử</Tab>
                )}
                <Tab>Định giá</Tab>
              </TabList>
              <TabPanels>
                {history && history.dinhGias?.length != 0 && (
                  <TabPanel padding={0}>
                    <LichSuGiaDat
                      key={history.dinhGias[0]?.tongGia}
                      thuaDatChiTiet={history}
                    />
                  </TabPanel>
                )}
                <TabPanel padding={0}>
                  <Box w="full" border="2px solid #fff" boxShadow="base">
                    <TableContainer w="full">
                      <Table size="sm">
                        <Tbody>
                          <Tr>
                            <Th w="30%">Định giá:</Th>
                            <Td>
                              <Dropdown
                                data={dsDinhGia}
                                selectedVal={indexDinhGia}
                                onChange={(val) =>
                                  setIndexDinhGia(val as number)
                                }
                              />
                            </Td>
                          </Tr>
                          <Tr>
                            <Th>Thửa liền kề:</Th>
                            <Td>{dinhGia?.thuaLienKe}</Td>
                          </Tr>
                          <Tr>
                            <Th>Tên đường:</Th>
                            <Td>{dinhGia?.tenDuong}</Td>
                          </Tr>
                          <Tr>
                            <Th>Tên hẻm:</Th>
                            <Td>{dinhGia?.tenHem}</Td>
                          </Tr>
                          <Tr>
                            <Th>Tên đường giao:</Th>
                            <Td>{dinhGia?.tenDuongGiao}</Td>
                          </Tr>
                          <Tr>
                            <Th>PP định giá:</Th>
                            {/* <Td>{dinhGia?.phuongPhapDinhGia}</Td> */}
                            <Td>{getDescription}</Td>
                          </Tr>
                          <Tr>
                            <Th>Hệ số tiếp giáp:</Th>
                            <Td>{dinhGia?.heSoTiepGiapDuong}</Td>
                          </Tr>
                          <Tr>
                            <Th>Tổng giá:</Th>
                            <Td>
                              {Number.isNaN(dinhGia?.tongGia) ||
                              dinhGia?.tongGia === 0
                                ? ""
                                : numberFormat(dinhGia?.tongGia || 0)}
                            </Td>
                          </Tr>
                          <Tr>
                            <Td>Đơn vị tính</Td>
                            <Td> 1.000 VNĐ</Td>
                          </Tr>
                          <Tr>
                            <Th>Giá thị trường:</Th>
                            <Td>
                              <Input
                                value={
                                  dinhGia?.giaThiTruong === 0
                                    ? ""
                                    : dinhGia?.giaThiTruong
                                }
                                type="number"
                                onChange={(e) =>
                                  handleChangeGiaValue(e.target.valueAsNumber)
                                }
                              />
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <Flex
                    w="full"
                    flexDirection="column"
                    mt="20px"
                    border="1px solid #fff"
                    padding="5px"
                    borderRadius="5px"
                    boxShadow="base"
                  >
                    <TableContainer w="full" overflowX="hidden">
                      <Table size="sm">
                        <Thead>
                          <Tr>
                            <Th paddingLeft="1px">Vị trí</Th>
                            <Th>DT Khu Vực</Th>
                            <Th>MĐSD</Th>
                            <Th>Diện tích (m&sup2;)</Th>
                            <Th>Giá (1.000vnđ)</Th>
                            <Th></Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {chiTiet.map((p, index) => {
                            return (
                              <Tr key={String(index)}>
                                <Td paddingLeft="1px">{p.tenVung}</Td>
                                <Td>{p.dienTichVung}</Td>
                                <Td>
                                  <Dropdown
                                    data={mdsd}
                                    selectedVal={p.mdsd}
                                    onChange={(v) =>
                                      handleChangeValue(index, v, "MDSD")
                                    }
                                  />
                                </Td>
                                <Td
                                  w="10%"
                                  paddingLeft="6px"
                                  paddingRight="2px"
                                >
                                  <InputCustom
                                    value={p.dienTich}
                                    onChange={(v) =>
                                      handleChangeValue(index, v, "DIEN_TICH")
                                    }
                                  />
                                </Td>
                                <Td
                                  w="20%"
                                  paddingLeft="6px"
                                  paddingRight="2px"
                                >
                                  <InputCustom
                                    value={p.gia}
                                    onChange={(v) =>
                                      handleChangeValue(index, v, "GIA")
                                    }
                                  />
                                </Td>
                                <Td padding="0px">
                                  <HStack>
                                    <Image
                                      cursor="pointer"
                                      w="18px"
                                      h="18px"
                                      src="./imgs/add.png"
                                      alt="thêm"
                                      onClick={() => {
                                        const newChitiet = [...chiTiet];
                                        newChitiet.splice(index, 0, p);
                                        setChiTiet(newChitiet);
                                      }}
                                    />

                                    {chiTiet.filter(
                                      (i) => i.tenVung === p.tenVung
                                    ).length > 1 && (
                                      <Image
                                        cursor="pointer"
                                        w="20px"
                                        h="20px"
                                        src="./imgs/close.png"
                                        alt="Xoá"
                                        onClick={() => {
                                          const newChitiet = [...chiTiet];
                                          newChitiet.splice(index, 1);
                                          setChiTiet(newChitiet);
                                        }}
                                      />
                                    )}
                                  </HStack>
                                </Td>
                              </Tr>
                            );
                          })}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Flex>
                  {isHasEditRole && (
                    <Button w="full" mt="10px" onClick={handleSaveClick}>
                      <Text>Lưu định giá</Text>
                    </Button>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </DrawerBody>
          {(isLoading || isRecal) && <WaitingModal />}
        </DrawerContent>
      </Drawer>
    </>
  );
}
